import { PASSCODE_LIST_TYPE } from '@/types/registration.types';
import { Post } from '../helpers';

export const GenerateMagicLinks = (channel: number, passcodeListId: number, eventUuid: string) => {
  return Post({
    path: `/v3/admin/events/magic-links/generate`,
    body: {
      channel,
      audience_list: passcodeListId,
      event_uuid: eventUuid,
      passcode_list_type: PASSCODE_LIST_TYPE.MAGIC_LINKS_REGISTRATION, // not true but fooling it
    },
  });
};

export const InvalidateMagicLinks = (passcodeListId: number, eventUuid: string, memberIds?: number[]) => {
  return Post({
    path: `/v3/admin/events/magic-links/invalidate`,
    body: {
      list_id: passcodeListId,
      event_uuid: eventUuid,
      member_ids: memberIds,
    },
  });
};

export const SendMagicLinkEmails = (eventUuid: string, passcodeListId: number) => {
  return Post({
    path: `/v3/admin/send-now-emails/send-magic-link/${eventUuid}`,
    body: {
      passcodeListId,
      skipAwait: true,
    },
  });
};
